export default __webpack_public_path__ + "static/media/particleHeartPrimary.1544bd91.svg";